module.exports = __webpack_public_path__ + "img/length.0318229c.png";